import styled from 'styled-components'



export const MainView = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -1;
  background: url("${props => props.image}");
  background-size: cover;
  background-position: center center;


  &:before{
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: ${props => props.theme.colors.black.primary};
    opacity: .5;
    z-index: -1;
  }
`

export const ParticlesWrapper = styled.div`
  opacity: 0;
`


export const MainContent = styled.div`
 background: white;
 margin-top: ${typeof window !== "undefined" ? `${window.innerHeight}px` : '100vh'};

`

export const CardWrapper = styled.div`
 background: white;
 margin-bottom: ${props => props.lastElement ? 0 : '1rem'};

${props => props.disabled && `
  opacity: .4;
`}

 @media (min-width:768px){
  margin-right: ${props => props.lastElement ? 0 : '1rem'};
 }



`



export const SloganWrapper = styled.div`
  position: absolute;
  top: 7rem;
  left: 0;
  right: 0;
  color: white;
  align-items: center;
  font-size: 1.5rem;

  letter-spacing: .4rem;
  @media (min-width: 768px){
    top: 6rem;
    font-size: 1.75rem;
  }
`

export const Slogan = styled.div`
  opacity: 0;
  color: white;
`
export const SubSlogan = styled.div`
  opacity: 0;
  color: ${props => props.theme.colors.primary};
`

export const Loading = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: ${props => props.theme.colors.black.primary};
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.primary};
  font-size: 2rem;
  opacity: .85;
`
export const IconWrapper = styled.div`
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translate(-50%,0);
  font-size: 1.25rem;
  color: white;
  &:hover{
    color: ${props => props.theme.colors.primary};
    cursor: pointer;
  }
`

export const MainVideoWrapper = styled.div`
  position: absolute;
  color: white;
  bottom: 4rem;
  left: 1rem;
  right: 1rem;
  opacity: 0;
  border-radius: 8px;
  padding: 10px;
  margin-right: 20px;
  overflow: hidden;
  background-color: rgba(255,255,255,0.2);
  @media (min-width: 768px){
    bottom: .5rem;
    color: white;
    left:auto;
    right: 1rem;
    width: 500px;
    height: auto;
    padding: 0;
  }
  h2 {
    color: white;
    padding: 10px;
  }
  p {
    padding: 10px;
    color: white;
  }
`


export const MainVideoSubtitle = styled.div`
  display: none;
  @media (min-width: 768px){
    display: block;
    margin-top: .5rem;
    color: white;
    font-weight: 300;
  }
`
